import { LucideLetterText, LucideListChecks, LucideListTodo, LucidePlus } from "lucide-react";
import { useBoolState } from "../../../hooks/bool-state.hook";
import { cn } from "../../../util/base.util";
import { MouseEvent, useEffect } from "react";
import FadeIn from "../../../components/generic/FadeIn";
import { useApi } from "../../../hooks/api.hook";
import { useNavigate } from "react-router";

export default function NewItemModal() {

    const bOpen = useBoolState();
    const noteApi = useApi("/list");
    const nav = useNavigate();

    const handleBgClick = (e: MouseEvent<HTMLDivElement>) => {
        if (e.target === e.currentTarget) {
            bOpen.disable();
        }
    }

    const createNote = async (type: 0|1) => {
        const res = await noteApi.post(undefined, {
            type
        });

        if (res.ok && !!res.data) {
            nav(`/lists/${res.data.id}`);
        }
    }

    useEffect(() => {

        if (bOpen.value) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }

    }, [bOpen.value]);

    return (
        <>
        <button onClick={bOpen.toggle} className={cn(
            "btn btn-circle btn-lg fixed z-[2] bottom-4 right-4 transition-all",
            bOpen.value ? 'rotate-45' : 'btn-primary'
        )}><LucidePlus /></button>

        {bOpen.value && (
            <div onClick={handleBgClick} className="bg-[#00000080] z-[1] fixed top-0 left-0 w-screen h-screen overflow-hidden">
                <div className="fixed right-4 bottom-16">
                    <FadeIn timeout={100}><button onClick={() => createNote(0)} className="btn btn-accent rounded-full p-2 px-4 flex items-center gap-2 m-4"><LucideLetterText /> Text Note</button></FadeIn>
                    <FadeIn><button onClick={() => createNote(1)} className="btn btn-accent rounded-full p-2 px-4 flex items-center gap-2 m-4"><LucideListTodo /> Check List</button></FadeIn>
                </div>
            </div>
        )}
        </>
    );
}